export default __webpack_public_path__ + "static/281-7099493474ed9d471b62ca19302e9064.gif";